import "./App.css";
import Header from "./components/Header.jsx";
import Solutions from "./components/Solutions";
import About from "./components/About";
import Work from "./components/Work";
import Footer from "./components/Footer";

function App() {
	return (
		<div className='App'>
			<div className='w-full min-h-screen p-4 pb-8 md:p-10 md:pt-34 md:pb-14 xl:pt-34 xl:px-165 xl:pb-68 flex flex-col items-center bg-light_cream overflow-hidden'>
				<Header />
				<Solutions />
				<About />
				<Work />
				<Footer />
			</div>
		</div>
	);
}

export default App;
